/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One pipeline stage of the job, for the "Job Stage" filter.
 */
export interface EnrollmentJobStageOption {
  id: string;
  name: string;
  color: string;
}
